/**
 * @desc Oauth2获取token
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(params: API.auth.authFacadeImpl.login.Params, options?: any) {
  return updateResponse(
    http(URL + `/oauth/token`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
